const APRIORI_JSON_STORAGE = 'APRIORI_JSON_STORAGE';
const APRIORI_TABLE_DATA_STORAGE = 'APRIORI_TABLE_DATA_STORAGE';

export const getAprioriJsonStorage = () : string => {
    return window.localStorage.getItem(APRIORI_JSON_STORAGE) ?? '';
};

export const saveAprioriJsonToStorage = (json: string) => {
    window.localStorage.setItem(APRIORI_JSON_STORAGE, json);
};

export const getAprioriTableDataStorage = () : string => {
    return window.localStorage.getItem(APRIORI_TABLE_DATA_STORAGE) ?? '';
};

export const saveAprioriTableDataToStorage = (tableData: string) => {
    window.localStorage.setItem(APRIORI_TABLE_DATA_STORAGE, tableData);
};